import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import FlagProvider from "@unleash/proxy-client-react";
import { configs as unleashConfigs } from "@monorepo/configs/unleash";

console.log(`Privacy Portal v${APP_VERSION}`);

const rootElem = document.getElementById("root");
const root = ReactDOM.createRoot(rootElem);
root.render(
    <FlagProvider config={unleashConfigs[ENV]}>
        <App />
    </FlagProvider>,
);
